import { DatiqUserPermissions } from './datiq-user.enums';
import {
    IDatiqUser,
    IDatiqUserModalInfo
} from './datiq-user.interface';

export const DATIQ_USER_CAPABILITY_KEY_PREFIX: string = `cp_`;

export const DATIQ_USER: string = 'Datiq User';
export const emptyDatiqUser: IDatiqUser = {
    id: '',
};

export const DatiqUserTierOne: DatiqUserPermissions[] = [
    DatiqUserPermissions.HotMarketMapsEnable,
];

export const DatiqUserTierTwo: DatiqUserPermissions[] = [
    DatiqUserPermissions.HotMarketMapsEnable,
    DatiqUserPermissions.EnableMarketConditionsGauge,
];

export const DatiqUserTierThree: DatiqUserPermissions[] = [
    DatiqUserPermissions.HotMarketMapsEnable,
    DatiqUserPermissions.EnableMarketConditionsGauge,
    DatiqUserPermissions.EnableMarketConditionsForecast,
];

export const emptyDatiqUserModalInfo: IDatiqUserModalInfo = {
    showAgain: true,
    first: true,
};
